import schedulesViewStateStore from "../../store/store";
import { INoteEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { IPreviewSchedulePageStore } from "../../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../../store/schema/SchedulesViewStateStore";

export default mutatorAction('SET_NOTES_IN_VIEW', function setNotesInView(
    notesInView: INoteEntity[],
    viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
) {
    const store = viewState ? viewState : schedulesViewStateStore();
    store.notesInView.clear();
    if (notesInView && notesInView.length) {
        for (let i = 0; i < notesInView.length; i++) {
            store.notesInView.set(notesInView[i].id, notesInView[i]);
        }
    }
});
